module.exports = __webpack_public_path__ + "static/media/suspension_black.be6e3587.png";